export default "__VITE_ASSET__8f070604__"